// extracted by mini-css-extract-plugin
export var acceptButton = "_27-5";
export var fullContent = "_27-4";
export var link = "_27-6";
export var linkIcon = "_27-7";
export var sideContent = "_27-3";
export var sideImage = "_27-2";
export var sideImageWrapper = "_27-1";
export var splitLayout = "_27-0";